import { useOuraData } from "../contexts/OuraDataContext";

/**
 * WHAT:
 *   Optimized Readiness Hook using centralized data context.
 *
 * WHY:
 *   Uses centralized data context instead of making separate API calls.
 *
 * @returns Object containing readiness data, error, loading state, and score
 *
 */
export const useOptimizedReadiness = () => {
  const { error, loading, readiness } = useOuraData();

  return {
    error,
    loading,
    readiness,
    score: readiness?.score ?? 0,
  };
};
